import { DocumentData, doc, getDoc } from 'firebase/firestore';
import { PremiumPuzzlePrice } from 'types/components/PremiumPuzzlePrice';

import { firestore } from '../Firebase';

export const getPremiumPuzzlePricesById = async (
  id: string,
): Promise<PremiumPuzzlePrice | null> => {
  const docRef = doc(firestore, '/economy/jpu/puzzle_prices', id);
  const docSnap: DocumentData = await getDoc(docRef);
  if (docSnap.exists()) return { ...docSnap.data(), id: docSnap.id };
  return null;
};
